import React, { FC, useContext } from 'react'
import {
    StyledControlButton,
    StyledPlayIcon,
    StyledStopIcon,
    StyledSpinner,
} from './ControlButton.styled'
import { TheWestLivePlayerStates } from '@news-mono/web-common'
import { RenderTargetContext } from '@news-mono/web-common'

export interface ControlButtonProps {
    className?: string
    state: TheWestLivePlayerStates
    bigButton?: boolean
    onClick: () => void
}

export const ControlButton: FC<ControlButtonProps> = ({
    className,
    state,
    bigButton,
    onClick,
}) => {
    const renderTarget = useContext(RenderTargetContext)

    return (
        <StyledControlButton
            type="button"
            onClick={renderTarget.renderTarget === 'web' ? onClick : undefined}
            onTouchEnd={
                renderTarget.renderTarget === 'app' ? onClick : undefined
            }
            bigButton={bigButton}
            className={className}
        >
            {state === 'stopped' && <StyledPlayIcon bigButton={bigButton} />}
            {state === 'loading' && <StyledSpinner bigButton={bigButton} />}
            {state === 'playing' && <StyledStopIcon bigButton={bigButton} />}
        </StyledControlButton>
    )
}
ControlButton.displayName = 'ControlButton'
